// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useEffect, useState } from "react";


let sessionExpired = false;
const listeners = new Set<() => void>();

export function notifySessionExpired(): void {
  if (sessionExpired) {
    return;
  }
  sessionExpired = true;
  listeners.forEach((listener) => listener());
}

export function resetSessionExpired(): void {
  if (!sessionExpired) {
    return;
  }
  sessionExpired = false;
  listeners.forEach((listener) => listener());
}

export function isSessionExpired(): boolean {
  return sessionExpired;
}

export function useSessionExpiredSignal(): boolean {
  const [value, setValue] = useState(sessionExpired);

  useEffect(() => {
    const listener = () => setValue(sessionExpired);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return value;
}
